import { render, staticRenderFns } from "./PopupGeneralAlert.vue?vue&type=template&id=71253723&scoped=true&"
import script from "./PopupGeneralAlert.vue?vue&type=script&lang=js&"
export * from "./PopupGeneralAlert.vue?vue&type=script&lang=js&"
import style0 from "./PopupGeneralAlert.vue?vue&type=style&index=0&id=71253723&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71253723",
  null
  
)

export default component.exports